import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-cc',
  templateUrl: './change-cc.component.html',
  styleUrls: ['./change-cc.component.css']
})
export class ChangeCcComponent implements OnInit {

  model = { 'table_name': 'trip', 'id': '', 'cost_center': '' };
  cc_detail = '';

  search_cc = {
    'placeholder': 'مركز التكلفة (الرئيسي)', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`cost_center`', 'selected_no': 'cc_id',
      'field_list': ['cc_name', 'cc_name_en']
    }]
  };

  Success_Msg; Error_Msg; CC_Placeholder;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private dialogRef: MatDialogRef<ChangeCcComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('CC_Placeholder').subscribe((res: string) => {
      this.CC_Placeholder = res;
    });
    this.search_cc['placeholder'] = this.CC_Placeholder;

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);
  }

  ngOnInit() {
    if (this.dialog_data != null) {
      this.model = this.dialog_data[0];

      let query, obj;

      // get cost center detail
      if (this.model['table_name'] == "trip") {

        query = "SELECT `trip`.`cost_center`, (CASE WHEN `trip`.`cost_center` != '0' THEN " + 
          "(SELECT `cost_center`.`cc_name` FROM `cost_center` WHERE `cost_center`.`cc_id` = `trip`.`cost_center`) " + 
          "ELSE '' END) AS 'cc_name', (CASE WHEN `trip`.`cost_center` != '0' THEN " + 
          "(SELECT `cost_center`.`cc_name_en` FROM `cost_center` WHERE " + 
          "`cost_center`.`cc_id` = `trip`.`cost_center`) ELSE '' END) AS 'cc_name_en' FROM `trip` WHERE " + 
          "`trip_id` = '" + this.model['id'] + "'";
      }
      else {
        query = "SELECT `flight`.`cost_center`, (CASE WHEN `flight`.`cost_center` != '0' THEN " + 
          "(SELECT `cost_center`.`cc_name` FROM `cost_center` WHERE `cost_center`.`cc_id` = `flight`.`cost_center`) " + 
          "ELSE '' END) AS 'cc_name', (CASE WHEN `flight`.`cost_center` != '0' THEN " + 
          "(SELECT `cost_center`.`cc_name_en` FROM `cost_center` WHERE " + 
          "`cost_center`.`cc_id` = `flight`.`cost_center`) ELSE '' END) AS 'cc_name_en' FROM `flight` WHERE " + 
          "`flight_id` = '" + this.model['id'] + "'";
      }
      
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let result = data.data['list'][0];

          if (result['cost_center'] != '0')
            this.cc_detail = result['cc_name'] + " - " + result['cc_name_en'];
        });
    }
  }

  onChangeCcSearch = function (search_result: object) {
  
    if (search_result['no'] != '')
      this.model['cost_center'] = search_result['no'];
    else
      this.model['cost_center'] = '0';
  }

  save() {
    // update the cost center field in trip or flight
    let values = [{ 'table_name': this.model['table_name'], 'cost_center': this.model['cost_center'] }];
    let where = [];
    if (this.model['table_name'] == "trip")
      where = [{ 'trip_id': this.model['id'] }];
    else 
      where = [{ 'flight_id': this.model['id'] }];

    let obj = { cmd: 'update', values: values, where: where };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        //console.log(data);
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.dialog_data = { 'op_type': 'success' };
          this.dialogRef.close(this.dialog_data);
        }
        else 
          alert(this.Error_Msg);
        
      });
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
